/* eslint-disable react/display-name */
/* eslint-disable camelcase */
/* eslint-disable comma-dangle */

import React from 'react';
import dynamic from 'next/dynamic';
import ExampleLoading from 'react-scale/components/website/index/Products/examples/exampleLoading';

const TaskResponseMultiShapes = dynamic(
  () => import('react-scale/components/website/index/Products/examples/tasks/multi-shapes'),
  {
    loading: () => <ExampleLoading />,
    ssr: false
  }
);
const TaskReponseLineAnnotation = dynamic(
  () => import('react-scale/components/website/index/Products/examples/tasks/lineannotation'),
  {
    loading: () => <ExampleLoading />,
    ssr: false
  }
);
const TaskResponseCuboidAnnotation = dynamic(
  () => import('react-scale/components/website/index/Products/examples/tasks/cuboidannotation'),
  {
    loading: () => <ExampleLoading />,
    ssr: false
  }
);

const responseCuboid = {
  annotations: [
    {
      label: 'car',
      vertices: [
        {
          type: 'vertex',
          x: 78,
          y: 296.3333435058594,
          description: 'face-topleft'
        },
        {
          type: 'vertex',
          x: 78,
          y: 1158.3333435058594,
          description: 'face-bottomleft'
        },
        {
          type: 'vertex',
          x: 577,
          y: 296.3333435058594,
          description: 'face-topright'
        },
        {
          type: 'vertex',
          x: 577,
          y: 1158.3333435058594,
          description: 'face-bottomright'
        },
        {
          type: 'vertex',
          x: 1339,
          y: 333.3333435058594,
          description: 'side-topcorner'
        },
        {
          type: 'vertex',
          x: 1339,
          y: 812.3333435058594,
          description: 'side-bottomcorner'
        }
      ],
      edges: [
        {
          type: 'edge',
          x1: 78,
          y1: 296.3333435058594,
          x2: 577,
          y2: 296.3333435058594,
          description: 'face-top'
        },
        {
          type: 'edge',
          x1: 577,
          y1: 296.3333435058594,
          x2: 577,
          y2: 1158.3333435058594,
          description: 'face-right'
        },
        {
          type: 'edge',
          x1: 577,
          y1: 1158.3333435058594,
          x2: 78,
          y2: 1158.3333435058594,
          description: 'face-bottom'
        },
        {
          type: 'edge',
          x1: 78,
          y1: 1158.3333435058594,
          x2: 78,
          y2: 296.3333435058594,
          description: 'face-left'
        },
        {
          type: 'edge',
          x1: 577,
          y1: 296.3333435058594,
          x2: 1339,
          y2: 333.3333435058594,
          description: 'side-top'
        },
        {
          type: 'edge',
          x1: 1339,
          y1: 333.3333435058594,
          x2: 1339,
          y2: 812.3333435058594,
          description: 'side-back'
        },
        {
          type: 'edge',
          x1: 1339,
          y1: 812.3333435058594,
          x2: 577,
          y2: 1158.3333435058594,
          description: 'side-bottom'
        }
      ]
    },
    {
      label: 'car',
      vertices: [
        {
          type: 'vertex',
          x: 1258.6,
          y: 464.333349609375,
          description: 'face-topleft'
        },
        {
          type: 'vertex',
          x: 1258.6,
          y: 703.533349609375,
          description: 'face-bottomleft'
        },
        {
          type: 'vertex',
          x: 1474.6,
          y: 464.333349609375,
          description: 'face-topright'
        },
        {
          type: 'vertex',
          x: 1474.6,
          y: 703.533349609375,
          description: 'face-bottomright'
        },
        {
          type: 'vertex',
          x: 1601.6,
          y: 460.333349609375,
          description: 'side-topcorner'
        },
        {
          type: 'vertex',
          x: 1601.6,
          y: 645.533349609375,
          description: 'side-bottomcorner'
        }
      ],
      edges: [
        {
          type: 'edge',
          x1: 1258.6,
          y1: 464.333349609375,
          x2: 1474.6,
          y2: 464.333349609375,
          description: 'face-top'
        },
        {
          type: 'edge',
          x1: 1474.6,
          y1: 464.333349609375,
          x2: 1474.6,
          y2: 703.533349609375,
          description: 'face-right'
        },
        {
          type: 'edge',
          x1: 1474.6,
          y1: 703.533349609375,
          x2: 1258.6,
          y2: 703.533349609375,
          description: 'face-bottom'
        },
        {
          type: 'edge',
          x1: 1258.6,
          y1: 703.533349609375,
          x2: 1258.6,
          y2: 464.333349609375,
          description: 'face-left'
        },
        {
          type: 'edge',
          x1: 1474.6,
          y1: 464.333349609375,
          x2: 1601.6,
          y2: 460.333349609375,
          description: 'side-top'
        },
        {
          type: 'edge',
          x1: 1601.6,
          y1: 460.333349609375,
          x2: 1601.6,
          y2: 645.533349609375,
          description: 'side-back'
        },
        {
          type: 'edge',
          x1: 1601.6,
          y1: 645.533349609375,
          x2: 1474.6,
          y2: 703.533349609375,
          description: 'side-bottom'
        }
      ]
    },
    {
      label: 'car',
      vertices: [
        {
          type: 'vertex',
          x: 1520.2,
          y: 480.933349609375,
          description: 'face-topleft'
        },
        {
          type: 'vertex',
          x: 1520.2,
          y: 618.533349609375,
          description: 'face-bottomleft'
        },
        {
          type: 'vertex',
          x: 1650.2,
          y: 480.933349609375,
          description: 'face-topright'
        },
        {
          type: 'vertex',
          x: 1650.2,
          y: 618.533349609375,
          description: 'face-bottomright'
        },
        {
          type: 'vertex',
          x: 1694.2,
          y: 478.933349609375,
          description: 'side-topcorner'
        },
        {
          type: 'vertex',
          x: 1694.2,
          y: 596.533349609375,
          description: 'side-bottomcorner'
        }
      ],
      edges: [
        {
          type: 'edge',
          x1: 1520.2,
          y1: 480.933349609375,
          x2: 1650.2,
          y2: 480.933349609375,
          description: 'face-top'
        },
        {
          type: 'edge',
          x1: 1650.2,
          y1: 480.933349609375,
          x2: 1650.2,
          y2: 618.533349609375,
          description: 'face-right'
        },
        {
          type: 'edge',
          x1: 1650.2,
          y1: 618.533349609375,
          x2: 1520.2,
          y2: 618.533349609375,
          description: 'face-bottom'
        },
        {
          type: 'edge',
          x1: 1520.2,
          y1: 618.533349609375,
          x2: 1520.2,
          y2: 480.933349609375,
          description: 'face-left'
        },
        {
          type: 'edge',
          x1: 1650.2,
          y1: 480.933349609375,
          x2: 1694.2,
          y2: 478.933349609375,
          description: 'side-top'
        },
        {
          type: 'edge',
          x1: 1694.2,
          y1: 478.933349609375,
          x2: 1694.2,
          y2: 596.533349609375,
          description: 'side-back'
        },
        {
          type: 'edge',
          x1: 1694.2,
          y1: 596.533349609375,
          x2: 1650.2,
          y2: 618.533349609375,
          description: 'side-bottom'
        }
      ]
    },
    {
      label: 'car',
      vertices: [
        {
          type: 'vertex',
          x: 1631.7333984375,
          y: 489.933349609375,
          description: 'face-topleft'
        },
        {
          type: 'vertex',
          x: 1631.7333984375,
          y: 576.333349609375,
          description: 'face-bottomleft'
        },
        {
          type: 'vertex',
          x: 1719.7333984375,
          y: 489.933349609375,
          description: 'face-topright'
        },
        {
          type: 'vertex',
          x: 1719.7333984375,
          y: 576.333349609375,
          description: 'face-bottomright'
        },
        {
          type: 'vertex',
          x: 1735.7333984375,
          y: 486.933349609375,
          description: 'side-topcorner'
        },
        {
          type: 'vertex',
          x: 1735.7333984375,
          y: 561.333349609375,
          description: 'side-bottomcorner'
        }
      ],
      edges: [
        {
          type: 'edge',
          x1: 1631.7333984375,
          y1: 489.933349609375,
          x2: 1719.7333984375,
          y2: 489.933349609375,
          description: 'face-top'
        },
        {
          type: 'edge',
          x1: 1719.7333984375,
          y1: 489.933349609375,
          x2: 1719.7333984375,
          y2: 576.333349609375,
          description: 'face-right'
        },
        {
          type: 'edge',
          x1: 1719.7333984375,
          y1: 576.333349609375,
          x2: 1631.7333984375,
          y2: 576.333349609375,
          description: 'face-bottom'
        },
        {
          type: 'edge',
          x1: 1631.7333984375,
          y1: 576.333349609375,
          x2: 1631.7333984375,
          y2: 489.933349609375,
          description: 'face-left'
        },
        {
          type: 'edge',
          x1: 1719.7333984375,
          y1: 489.933349609375,
          x2: 1735.7333984375,
          y2: 486.933349609375,
          description: 'side-top'
        },
        {
          type: 'edge',
          x1: 1735.7333984375,
          y1: 486.933349609375,
          x2: 1735.7333984375,
          y2: 561.333349609375,
          description: 'side-back'
        },
        {
          type: 'edge',
          x1: 1735.7333984375,
          y1: 561.333349609375,
          x2: 1719.7333984375,
          y2: 576.333349609375,
          description: 'side-bottom'
        }
      ]
    }
  ]
};

const responseLine = {
  annotations: [
    {
      key: '686b1d21-e52e-4a97-8271-c4623c1c1250',
      vertices: [
        {
          x: 1276,
          y: 1198
        },
        {
          x: 1808,
          y: 620.0000000000001
        }
      ],
      label: 'solid line'
    },
    {
      key: 'b48d819f-8224-4079-80c8-6772ebd075b3',
      vertices: [
        {
          x: 1090,
          y: 1196
        },
        {
          x: 1288,
          y: 1038
        },
        {
          x: 1556,
          y: 808
        },
        {
          x: 1784,
          y: 604
        }
      ],
      label: 'solid line'
    },
    {
      key: '1e9812de-eb27-4c81-8056-ed24e669aa14',
      vertices: [
        {
          x: 4,
          y: 1056
        },
        {
          x: 1714,
          y: 564
        }
      ],
      label: 'solid line'
    },
    {
      key: '33d00497-e027-4de5-b120-23a54265c0c7',
      vertices: [
        {
          x: 4,
          y: 1016
        },
        {
          x: 1578,
          y: 580
        }
      ],
      label: 'solid line'
    },
    {
      key: 'cce86a89-288a-42ba-a43e-ae386d1ef460',
      vertices: [
        {
          x: 956,
          y: 760
        },
        {
          x: 1520,
          y: 834
        }
      ],
      label: 'solid line'
    },
    {
      key: '75a151c5-3e8e-4428-a88d-64f06429a37c',
      vertices: [
        {
          x: 1292,
          y: 656
        },
        {
          x: 1686,
          y: 688
        }
      ],
      label: 'solid line'
    }
  ]
};

export default () => (
  <TaskResponseMultiShapes imageURL="/static/img/website/solutions/robotics/slider/slide-3.jpg">
    <TaskReponseLineAnnotation annotations={responseLine.annotations} bgTransparent responsive />
    <TaskResponseCuboidAnnotation
      hover
      annotations={responseCuboid.annotations}
      bgTransparent
      responsive
      rounded
    />
  </TaskResponseMultiShapes>
);
